import React from 'react';
import { layout, MarginProps, space, WidthProps } from 'styled-system';
import tinycolor from 'tinycolor2';
import { Paragraph, styled, theme, Theme } from '@staffino/primitive-controls';

type StyledLabelProps = WidthProps &
  MarginProps & {
    activeColor?: string;
    colored?: boolean;
    theme?: Theme;
  };

const StyledLabel = styled.label<StyledLabelProps>(
  (props) => ({
    cursor: 'pointer',
    'input:checked + & > div, input:checked + &:hover > div': {
      backgroundColor: props.activeColor || props.theme.colors.primary,
      color: !props.colored && 'white',
      border: 0,
    },
    'input:checked + & > div': {
      color: !props.colored && 'white',
    },
    'input:checked + &:hover > div': {
      boxShadow: `0rem 7px 15px 0rem ${tinycolor(
        props.activeColor || props.theme.colors.primary,
      )
        .setAlpha(0.3)
        .toRgbString()}`,
    },
    '& > div': {
      transition: 'margin 300ms',
    },
    '&:hover > div': {
      backgroundColor: !props.colored
        ? props.theme.colors.separator
        : props.activeColor,
      boxShadow: `0rem 7px 15px 0rem ${tinycolor(
        !props.colored ? props.theme.colors.separator : props.activeColor,
      )
        .setAlpha(0.3)
        .toRgbString()}`,
      // [props.theme.mq.medium]: {
      // hover animation turned off
      // marginTop: 0,
      // marginBottom: '0.625rem',
      // },
    },
  }),
  layout,
  space,
);

const HiddenRadio = styled.input({
  position: 'absolute',
  width: 0,
  height: 0,
  opacity: 0,
});

export default function NumberButton({
  score,
  color,
  colored,
  inactiveColor,
  name,
  innerRef,
  first,
  last,
  isSelected,
  onChange,
}) {
  return (
    <>
      <HiddenRadio
        ref={innerRef}
        type="radio"
        name={name}
        defaultChecked={isSelected}
        defaultValue={score}
        id={`${name}.${score}`}
        onChange={() => onChange?.(score)}
      />
      <StyledLabel
        htmlFor={`${name}.${score}`}
        activeColor={color}
        colored={colored}
        width={[
          1,
          '2.1875rem',
          theme.mq.tablet ? '2.7rem' : '2.375rem',
          '3.125rem',
        ]}
        margin="1px 0"
        marginLeft={[0, first ? 0 : '0.09375rem']}
        marginRight={[0, last ? 0 : '0.09375rem']}
      >
        {colored ? (
          <Paragraph
            width={1}
            color="white"
            fontSize="1.125rem"
            fontWeight="bold"
            backgroundColor={inactiveColor}
            borderRadius="4px"
            marginTop={[0, '0.625rem']}
            height={['2.5rem', '3.125rem']}
            textAlign="center"
            justifyContent="center"
          >
            {score}
          </Paragraph>
        ) : (
          <Paragraph
            width={1}
            color="#586474"
            fontSize="1.125rem"
            fontWeight="bold"
            backgroundColor="#ffffff"
            border="solid 2px #d8e1eb"
            borderRadius="4px"
            marginTop={[0, '0.625rem']}
            height={['2.5rem', '3.125rem']}
            textAlign="center"
            justifyContent="center"
          >
            {score}
          </Paragraph>
        )}
      </StyledLabel>
    </>
  );
}
